import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/CreateAdmin.css";
import axios from "axios";
import { GridLoader } from "react-spinners";

function UpdateUsers() {
  const navigate = useNavigate();
  const location = useLocation();

  const [availableGroupIds, setAvailableGroupIds] = useState([]);
  const baseURL = sessionStorage.getItem('baseURL')

  const [newUser, setNewUser] = useState({
    unitName: "",
    email: "",
    employeeId: "",
    name: ""
  });
  const [oldUser, setOldUser] = useState("");

  const [fieldErrors, setFieldErrors] = useState({});

  /* -------------------- AUTH & LOAD -------------------- */

  useEffect(() => {
    if (sessionStorage.getItem("isLoggedIn") !== "true") {
      navigate("/");
    } else if (sessionStorage.getItem("isAdmin") !== "true") {
      navigate("/dashboard");
    } else {
      fetchGroupIds();
    }
  }, [navigate]);

  const fetchGroupIds = async () => {
    try {
      document.getElementById("loading").hidden = false;
      const res = await axios.get(
        baseURL+"pu/getGroupIds"
      );
      let units = [];
      for (const u of res.data) {
        units.push(u.production_unit_name);
      }
      setAvailableGroupIds(units);
      let user = JSON.parse(sessionStorage.getItem('userData'));
      let productionUnit = sessionStorage.getItem('productionUnit');
      setNewUser({
        unitName: productionUnit,
        email: user[3],
        employeeId: user[1],
        name: user[2]
      });
      setOldUser(user[1])

    } catch (err) {
      console.error("Error fetching group IDs", err);
      setAvailableGroupIds([]);
    } finally {
      document.getElementById("loading").hidden = true;
    }
  };

  /* -------------------- HANDLERS -------------------- */

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prev) => ({ ...prev, [name]: value }));
    setFieldErrors((prev) => ({ ...prev, [name]: false }));
  };

  /* -------------------- VALIDATION -------------------- */

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateFields = () => {
    const errors = {};


    if (!newUser.unitName.trim()) {
      errors.unitName = "Production Unit Name is required";
    }

    if (!newUser.email.trim()) {
      errors.email = "Email is required";
    }
    else if (!validateEmail(newUser.email.trim())) {
      errors.email = "Invalid email format";
    }

    if (!newUser.name.trim()) {
      errors.name = "Name is required";
    }

    if (!newUser.employeeId.trim()) {
      errors.employeeId = "Employee ID is required";
    }

    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };
  function showToast(message, type = "success") {
    const toast = document.createElement("div");
    toast.innerText = message;

    Object.assign(toast.style, {
      position: "fixed",
      top: "20px",
      right: "20px",
      background: type === "error" ? "#d32f2f" : type === "success" ? "#2e7d32" : "#ffa000",
      color: "#fff",
      padding: "12px 18px",
      borderRadius: "6px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      zIndex: 9999,
      opacity: "0",
      transition: "opacity 0.3s ease"
    });

    document.body.appendChild(toast);

    requestAnimationFrame(() => (toast.style.opacity = "1"));

    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }
  /* -------------------- SUBMIT -------------------- */

  const handleUpdateUser = async () => {
    if (!validateFields()) return;

    document.getElementById("loading").hidden = false;
    const formData = new FormData();
    formData.append("productionUnitName", newUser.unitName);
    formData.append("email", newUser.email);
    formData.append("employeeId", newUser.employeeId.toLowerCase());
    formData.append("name", newUser.name);
    formData.append("oldEmpID", oldUser);

    try {
      axios.post(baseURL+"auth/updateUser", formData, {
        headers: {
          "Authorization": `Bearer ${sessionStorage.getItem("token")}`
        }
      }).then((response) => {
        showToast("User Updated Successfully");
        navigate("/users");
      });
    } catch (err) {
      console.error("Update User failed", err);
      showToast("Error Adding User. Please Try after sometime", "error");
    } finally {
      document.getElementById("loading").hidden = true;
    }
  };

  /* -------------------- UI -------------------- */

  return (
    <div className="container-fluid py-4">
      <div className="card p-4 admin-page">
        <h2 className="text-center mb-4" style={{ color: "#4a5160" }}>User Management</h2>

        {/* ---------- Production Unit Selector ---------- */}


        <div className="mb-3">
          <label>Production Unit Name *</label>
          <div className="input-group">
            <select
              className={`form-control ${fieldErrors.unitName ? "is-invalid" : ""}`}
              value={newUser.unitName}
              name='unitName'
              onChange={handleInputChange}
            >
              <option value="">Select Production Unit</option>
              {availableGroupIds.map((unit) => (
                <option key={unit} value={unit}>
                  {unit}
                </option>
              ))}
            </select>
            {fieldErrors.unitName && (
              <div className="invalid-feedback">
                {fieldErrors.unitName}
              </div>
            )}
          </div>
        </div>
        <div className="mb-3">
          <label>Employee ID *</label>
          <div className="input-group">
            <input
              type="text"
              className={`form-control ${fieldErrors.employeeId ? "is-invalid" : ""}`}
              name="employeeId"
              value={newUser.employeeId}
              onChange={handleInputChange}
              placeholder="Enter Employee ID"
            />
            {fieldErrors.employeeId && (
              <div className="invalid-feedback">
                {fieldErrors.employeeId}
              </div>
            )}
          </div>
        </div>

        <div className="mb-3">
          <label>Name *</label>
          <div className="input-group">
            <input
              type="text"
              className={`form-control ${fieldErrors.name ? "is-invalid" : ""}`}
              name="name"
              value={newUser.name}
              onChange={handleInputChange}
              placeholder="Enter Name"
            />
            {fieldErrors.name && (
              <div className="invalid-feedback">
                {fieldErrors.name}
              </div>
            )}
          </div>
        </div>
        <div className="mb-3">
          <label>Email *</label>
          <div className="input-group">
            <input
              type="email"
              className={`form-control ${fieldErrors.email ? "is-invalid" : ""}`}
              name="email"
              value={newUser.email}
              onChange={handleInputChange}
              placeholder="Enter Email"
            />
            {fieldErrors.email && (
              <div className="invalid-feedback">
                {fieldErrors.email}
              </div>
            )}
          </div>
        </div>

        {/* ---------- Actions ---------- */}
        <div className="text-center">
          <button
            className="btn btn-secondary me-2"
            onClick={() => navigate("/users")}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleUpdateUser}
          >
            Update User
          </button>
        </div>
      </div>

      <div className="loading" id="loading">
        <GridLoader color="#4a5160" size={20} />
      </div>
    </div >
  );
}

export default UpdateUsers;
